import { Bold } from './Bold.tsx';
import { BulletList } from './BulletList.tsx';
import { Italic } from './Italic.tsx';
import { Link } from './Link.tsx';
import { OrderedList } from './OrderedList.tsx';
import { Strike } from './Strike.tsx';
import { Subscript } from './Subscript.tsx';
import { Superscript } from './Superscript.tsx';
import { Underline } from './Underline.tsx';

export const RichTextEditorIcons = {
  Bold,
  BulletList,
  Italic,
  Link,
  OrderedList,
  Strike,
  Subscript,
  Superscript,
  Underline,
};

export default RichTextEditorIcons;
